"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_THREAD_EVENTS_SORT_COLUMNS = [
    "createdAt",
    "updatedAt",
    "id",
    "type",
];
//# sourceMappingURL=get-thread-events-parameters.js.map